/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosError } from 'axios'
import { User } from '@/types/user'
import { useAuthStore } from '@/stores/authStore'
import { axiosInstance } from '@/lib/axios'
import { LoginRequest, LoginResponse } from '../types/auth'
import BaseService from './baseService'

class AuthService extends BaseService {
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    try {
      const API_URL = import.meta.env.VITE_API_URL

      const { data } = await axios.post<LoginResponse>(
        `${API_URL}/user/login`,
        {
          username: credentials.username,
          password: credentials.password,
          created_type: credentials.created_type,
        },
        {
          headers: {
            accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      )
      return data
    } catch (error) {
      if (error instanceof AxiosError && error.response?.data) {
        console.log()
        // return {
        //   status: false,
        //   message: error.response.data.message || 'Login failed',
        //   data: null,
        // } as LoginResponse
        return {
          access_token: '',
          refresh_token: '',
          token_type: '',
          user: null as unknown as User,
          message:
            (error.response?.data as { detail?: string })?.detail ||
            'Login failed',
        } as LoginResponse
      }
      throw error
    }
  }

  async refreshToken(
    access_token: string,
    refresh_token: string
  ): Promise<any> {
    try {
      // Use fetch/axios directly to avoid BaseService auth header coupling
      const API_URL = import.meta.env.VITE_API_URL
      const res = await fetch(`${API_URL}/user/refresh`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${access_token}` },
        body: JSON.stringify({ refresh_token }),
        credentials: 'include',
      })
      const data = await res.json()
      if (!res.ok) throw data
      return data
    } catch (error) {
      if (error instanceof AxiosError && error.response?.data) {
        throw new Error(
          error.response.data.message || 'Failed to refresh token'
        )
      }
      throw error
    }
  }

  async getMe() {
    try {
      const response = await axiosInstance.get(`/user/me`)
      return response.data
    } catch (error) {
      useAuthStore.getState().auth.reset()
      throw error
    }
  }

  async logout() {
    try {
      useAuthStore.getState().auth.reset()
      // await this.post(`/api/v1/auth/logout`)

      return true
    } catch (_error) {
      useAuthStore.getState().auth.reset()
      return true
    }
  }
}

export const authService = new AuthService()
